import React, {
    useState, useEffect, useCallback, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {BreakpointTrackerContext} from "@jutro/layout";
import { useAuthentication } from 'gw-digital-auth-react';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import {
    Loader, FormattedDate
} from '@jutro/components';
import metadata from './InvoicesPage.metadata.json5';
import {Currency as CurrencyField} from "gw-components-platform-react";
import {getMetadataByBreakPoint} from "../utils/breakpointUtil";
import {TranslatorContext} from "@jutro/locale";

function InvoicesPage() {
    const { authHeader } = useAuthentication();
    const [invoicesData, setInvoicesData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);

    const formatMessages = useCallback((globalInvoices) => {
        console.log(globalInvoices);
        setInvoicesData(globalInvoices);
    }, []);

    const getDateModified = useCallback((items, index, { path: property }) => {
        if (typeof items[property] === 'undefined') {
            return '';
        }
        return <FormattedDate value={new Date(items[property])} format="short" />;
    }, []);

    const getCellPremium = useCallback((rowData, rowIndex) => {
        return (
            <CurrencyField
                id={`totalamount_${rowIndex}`}
                value={rowData.totalAmount}
                readOnly
            />
        );
    }, []);

    const getCellStatus = useCallback((rowData, rowIndex) => {
        return translator({
            id: `typekey.ServiceRequestInvoiceStatus.${rowData.status}`,
            defaultMessage: ''
        });
    }, []);

    useEffect(() => {
        setLoadingState(true);
        ServiceRequestService.getInvoicesForSpecialist(authHeader).then(
            formatMessages
        ).finally(() => {
            setLoadingState(false);
        });
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const override = {
        '@field': {
            labelPosition: 'left'
        },
        invoiceTable: {
            data: invoicesData
        },
        invoiceTotalAmountColumn: {
            onCell: getCellPremium
        },
        invoiceStatusColumn: {
            onCell: getCellStatus
        }
    };

    const resolvers = {
        /*resolveClassNameMap: styles*/
        resolveCallbackMap: {
            getDateModified: getDateModified
        }
    };

    return renderContentFromMetadata(getMetadataByBreakPoint(metadata, breakpoint), override, resolvers);
}

export default withRouter(InvoicesPage);
